export default ({ app }, inject) => {
	const tenantType = {
		hyogo: {
			name: '兵庫県',
			link_term: {
				user: '/terms/user/テレワーク兵庫利用規約_県.pdf',
				tenantadmin: '/terms/tenad/テレワーク兵庫利用規約_県.pdf',
			},
			link_manual: {
				user: '/manual_user_hyogo.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_mac: {
				user: '/manual_user_mac_hyogo.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_android: {
				user: '/manual_user_android_hyogo.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
		},
		city: {
			name: '市町',
			link_term: {
				user: '/terms/user/テレワーク兵庫市町用利用規則.pdf',
				tenantadmin: '/terms/tenad/テレワーク兵庫市町用管理規則.pdf',
			},
			link_manual: {
				user: '/manual_user.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_mac: {
				user: '/manual_user_mac.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_android: {
				user: '/manual_user_android.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
		},
		company: {
			name: '企業',
			link_term: {
				user: '/terms/user/テレワーク兵庫企業用利用規則.pdf',
				tenantadmin: '/terms/tenad/テレワーク兵庫企業用管理規則.pdf',
			},
			link_manual: {
				user: '/manual_user.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_mac: {
				user: '/manual_user_mac.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_android: {
				user: '/manual_user_android.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
		},
		hyosec: {
			name: 'HYOSEC',
			link_term: {
				user: '/terms/user/テレワーク兵庫市町用利用規則.pdf',
				tenantadmin: '/terms/tenad/テレワーク兵庫市町用利用規則.pdf',
			},
			link_manual: {
				user: '/manual_user_hyogo.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_mac: {
				user: '/manual_user_mac_hyogo.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_android: {
				user: '/manual_user_android.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
		},
		'board-of-edu': {
			name: '市町教育委員会',
			link_term: {
				user: '/terms/user/テレワーク兵庫市町用利用規則.pdf',
				tenantadmin: '/terms/tenad/テレワーク兵庫市町用管理規則.pdf',
			},
			link_manual: {
				user: '/manual_user.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_mac: {
				user: '/manual_user_mac.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_android: {
				user: '/manual_user_android.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
		},
		default: {
			name: 'その他組織',
			link_term: {
				user: '/terms/user/テレワーク兵庫利用規約.pdf',
				tenantadmin: '/terms/user/テレワーク兵庫利用規約.pdf',
			},
			link_manual: {
				user: '/manual_user.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_mac: {
				user: '/manual_user_mac.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
			link_manual_android: {
				user: '/manual_user_android.pdf',
				tenantadmin: '/manual_tenad.pdf',
			},
		},
		getTypeName() {
			return this.hasOwnProperty(app.$auth.user.tenant_type) ? app.$auth.user.tenant_type : 'default';
		},
		get() {
			return this[this.getTypeName()];
		},
		isTypeHyogo() {
			let type = this.getTypeName();
			return type == 'hyogo' || type == 'hyosec';
		},
		isTypeCity() {
			return this.getTypeName() == 'city';
		},
		isTypeCompany() {
			return this.getTypeName() == 'company';
		},
		isHideTerms() {
			return false;
		},
		isHideApplicationDl() {
			return !(this.isTypeCity() || this.isTypeCompany());
		},
		getName() {
			return this.get().name;
		},
		getUserTermLink() {
			return this.get().link_term.user;
		},
		getUserManualLink() {
			return this.get().link_manual.user;
		},
		getUserManualLinkMac() {
			return this.get().link_manual_mac.user;
		},
		getUserManualLinkAndroid() {
			return this.get().link_manual_android.user;
		},
		getTenadTermLink() {
			return this.get().link_term.tenantadmin;
		},
		getTenadManualLink() {
			return this.get().link_manual.tenantadmin;
		},
	};

	inject('tenantType', tenantType);
};
